import React from 'react';
import PropTypes from 'prop-types';

export function FacilityUnitMicroData({
	storageUnits,
	vehicleUnits,
	facilityName,
	facilityUrl,
	facilityImageUrl,
	baseUrl,
}) {
	const createProductSchemas = () => {
		const schemas = [];
		const sanitizeSizeText = (sizeText) => sizeText.replace(/['\s]/g, '');

		storageUnits.forEach((unit) => {
			schemas.push({
				'@context': 'https://schema.org',
				'@type': 'Product',
				'@id': `${baseUrl}${facilityUrl}#${unit.id}#${sanitizeSizeText(unit.sizeText)}#product`,
				name: `${unit.sizeText} Storage Unit`,
				description: `${unit.sizeText} Storage Unit - ${facilityName}`,
				url: `${baseUrl}${facilityUrl}`,
				brand: {
					'@type': 'Brand',
					name: facilityName,
				},
				offers: {
					'@type': 'Offer',
					price: unit.price.value,
					priceCurrency: 'USD',
					availability: 'https://schema.org/InStock',
				},
				...(facilityImageUrl && { image: facilityImageUrl }),
			});
		});

		vehicleUnits.forEach((unit) => {
			schemas.push({
				'@context': 'https://schema.org',
				'@type': 'Product',
				'@id': `${baseUrl}${facilityUrl}#${unit.id}#${sanitizeSizeText(unit.sizeText)}#product`,
				name: `${unit.sizeText} Vehicle Storage`,
				description: `${unit.sizeText} Vehicle Storage - ${facilityName}`,
				url: `${baseUrl}${facilityUrl}`,
				brand: {
					'@type': 'Brand',
					name: facilityName,
				},
				offers: {
					'@type': 'Offer',
					price: unit.price.value,
					priceCurrency: 'USD',
					availability: 'https://schema.org/InStock',
				},
				...(facilityImageUrl && { image: facilityImageUrl }),
			});
		});

		return schemas;
	};

	const productSchemas = createProductSchemas();

	return (
		<>
			{productSchemas.map((schema, index) => (
				<script
					key={`${schema['@id']}-${index}`}
					type="application/ld+json"
					dangerouslySetInnerHTML={{ __html: JSON.stringify(schema).replace(/</g, '\\u003c') }}
				/>
			))}
		</>
	);
}

FacilityUnitMicroData.propTypes = {
	storageUnits: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			sizeText: PropTypes.string.isRequired,
			price: PropTypes.shape({
				value: PropTypes.number.isRequired,
			}).isRequired,
		})
	).isRequired,
	vehicleUnits: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
			sizeText: PropTypes.string.isRequired,
			price: PropTypes.shape({
				value: PropTypes.number.isRequired,
			}).isRequired,
		})
	).isRequired,
	facilityName: PropTypes.string.isRequired,
	facilityUrl: PropTypes.string.isRequired,
	facilityImageUrl: PropTypes.string,
	baseUrl: PropTypes.string.isRequired,
};
